export default "__VITE_ASSET__G2NfGzmr__"